import React from 'react';
import './App.css';
import { Web3ReactProvider } from "@web3-react/core";
import { getLibrary, Web3ProviderNetwork } from "./context/web3provider";
import { RefreshContextProvider } from "./context/RefreshContext";

import {
  Route,
  Routes,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";


import Home from './page';
import Airdrop from './page/airdrop';
import Refer from './page/refer';
import WallPaper from './page/wallpaper';
import MintNFT from './page/NFT/MintNFT';
import DetailNft from './page/NFT/DetailNFT';
import OwnerNFT from './page/NFT/OwnerNFT';
// import Collection from './page/NFT/Collection';
import MyNFT from './page/NFT/MyNFT';
import HomeNFT from './page/NFT/HomeNFT';


function App() {
  i18next.init({
    interpolation: { escapeValue: false },
  });
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3ProviderNetwork getLibrary={getLibrary}>
        <RefreshContextProvider>
          <I18nextProvider i18n={i18next}>
            <Routes>
              <Route path="/" element={<HomeNFT />} />
              {/* <Route path="/cuong" element={<Airdrop />} /> */}
              <Route path='/gecko-nft' element={<MintNFT />} />
              {/* <Route path='/wallpaper' element={<WallPaper />} /> */}
              <Route path='/detailNFT/:id' element={<DetailNft />} />
              <Route path='/ownerNFT/:id' element={<OwnerNFT />} />
              {/* <Route path='/explore' element={<Collection />} /> */}
              <Route path='/my-nft' element={<MyNFT />} />
              {/* <Route path='/home-nft' element={<HomeNFT />} /> */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </I18nextProvider>

        </RefreshContextProvider>
      </Web3ProviderNetwork>
    </Web3ReactProvider>



  );
}

export default App;
